<template>
  <div class="personal-home">
    <div class="my-order">
      <div class="title">我的订单</div>
      <div class="my-order-main">
        <ul class="list">
          <li @click="goToOrder(0)">
            <span class="number">{{ statusNoPay }}</span>
            <span>待付款</span>
          </li>
          <li @click="goToOrder(8)">
            <span class="number">{{ statusNoReceived }}</span>
            <span>待收货</span>
          </li>
          <li @click="goToOrderReturn(1)">
            <span class="number">{{ refundStatusNoRefundGoods }}</span>
            <span>待退货</span>
          </li>
          <li @click="goToOrderReturn(4)">
            <span class="number">{{ refundStatusNoReceivedMoney }}</span>
            <span>退款确认</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="my-collection">
      <div class="title">我的收藏</div>
      <div class="my-collection-main">
        <ul class="list" v-if="collectionList.length>0">
          <li v-for="(value, index) in collectionList" :key="index">
            <img v-if="value.img" :src="value.img" alt @click="goToProduct(value.goodsId)" />
            <img
              v-else
              src="http://image.8844it.com/ydb2/goodDefault.png"
              alt
              @click="goToProduct(value.goodsId)"
            />
            <p class="tit" :title="value.name" @click="goToProduct(value.goodsId)">{{ value.name }}</p>
            <p class="price">￥{{ value.price }}</p>
          </li>
        </ul>
        <div v-if="collectionList.length>0" class="more" @click="toCollection">
          <svg
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3432"
            width="32"
            height="32"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <path
              d="M480 928a384 384 0 1 1 0-768 384 384 0 0 1 0 768z m0-64a320 320 0 1 0 0-640 320 320 0 0 0 0 640z m50.752-320L425.344 438.656a32 32 0 1 1 45.312-45.312l128 128a32 32 0 0 1 0 45.312l-128 128a32 32 0 0 1-45.312-45.312L530.752 544z"
              p-id="3433"
              fill="#e4e4e4"
            />
          </svg>
        </div>
        <div class="no-collectionList" v-if="collectionList.length === 0">暂无数据</div>
      </div>
    </div>
    <div class="my-recommend">
      <div class="title">
        <span>推荐商品</span>
      </div>
      <div class="my-recommend-main">
        <ul class="list" v-if="recommendList.length>0">
          <li v-for="(value,index) in recommendList" :key="index">
            <img v-if="value.img" :src="value.img" alt @click="goToProduct(value.goodsId)" />
            <img
              v-else
              src="http://image.8844it.com/ydb2/goodDefault.png"
              @click="goToProduct(value.goodsId)"
              alt
            />
            <p class="tit" @click="goToProduct(value.goodsId)">{{value.name}}</p>
            <p class="price">￥{{ value.price }}</p>
          </li>
        </ul>
        <div class="no-recommendList" v-if="recommendList.length === 0">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import XBpersonalHome from 'models/xb/personalHome.js';
const xbpersonalHome = new XBpersonalHome();
export default {
  data() {
    return {
      refundStatusNoReceivedMoney: 0,
      refundStatusNoRefundGoods: 0,
      statusNoPay: 0,
      statusNoReceived: 0,
      collectionList: [
        // {
        //   name: 'kkkkkkkkkk',
        //   img: 'https://i1.mifile.cn/a1/pms_1550642182.7527088!220x220.jpg',
        //   price: 1230
        // }
      ],
      recommendList: []
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    // 获取个人中心数据
    getData() {
      xbpersonalHome.postXBPersonalHome().then(res => {
        if (res.success) {
          console.log(res);
          this.refundStatusNoReceivedMoney =
            res.result.order.refundStatusNoReceivedMoney;
          this.refundStatusNoRefundGoods =
            res.result.order.refundStatusNoRefundGoods;
          this.statusNoPay = res.result.order.statusNoPay;
          this.statusNoReceived = res.result.order.statusNoReceived;
          let arr = [];
          res.result.xbCollectionList.map((value, index, array) => {
            let obj = {};
            obj.id = value.id;
            obj.goodsId = value.goodsId;
            obj.name = value.goodsName;
            obj.img = value.goodsPic;
            obj.price = value.defaultPrice;
            arr.push(obj);
          });
          this.collectionList = arr;
          let recommendArr = [];
          res.result.recommendGoods.map((value, index, array) => {
            let obj = {};
            obj.id = value.id;
            obj.goodsId = value.goodsId;
            obj.name = value.goodsName;
            obj.img = value.itemImages[0] ? value.itemImages[0] : '';
            obj.price = value.defaultPrice;
            recommendArr.push(obj);
          });
          this.recommendList = recommendArr;
        }
      });
    },
    // 前往订单页面
    goToOrder(status) {
      this.$router.push({
        path: '/personal/personal-menu/xb-order',
        query: {
          status
        }
      });
    },
    // 前往退货单页面
    goToOrderReturn(status) {
      this.$router.push({
        path: '/personal/personal-menu/xb-order-return',
        query: {
          status
        }
      });
    },
    // 前往我的收藏
    toCollection() {
      this.$router.push('/personal/personal-menu/xb-collection');
    },
    // 前往商品详情页
    goToProduct(id) {
      let routeUrl = this.$router.resolve({
        path: '/product',
        query: {
          id: id
        }
      });
      window.open(routeUrl.href, '_blank');
    }
  }
};
</script>
<style lang='scss' scoped>
.personal-home {
  min-height: 750px;
  background: #f7f7f7;
  .title {
    font-size: 16px;
    color: rgba(96, 98, 102, 1);
    line-height: 40px;
    letter-spacing: 1px;
    border-bottom: 1px solid #e4e4e4;
    box-sizing: border-box;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .change-group {
      font-size: 12px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .change-group:hover {
      color: rgba(223, 52, 69, 1);
      svg {
        fill: rgba(223, 52, 69, 1);
      }
    }
  }
  .my-order {
    padding: 0 20px;
    background: #fff;
    margin-bottom: 20px;
    .my-order-main {
      height: 120px;
      display: flex;
      .list {
        flex: 1;
        display: flex;
        justify-content: space-around;
        align-items: center;
        li {
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          .number {
            font-size: 24px;
            color: rgba(232, 54, 50, 1);
            line-height: 33px;
          }
          span {
            font-size: 14px;
            color: rgba(96, 98, 102, 1);
            line-height: 20px;
            letter-spacing: 1px;
          }
        }
      }
    }
  }
  .my-collection {
    padding: 0 20px;
    background: #fff;
    margin-bottom: 20px;
    .my-collection-main {
      height: 180px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .list {
        display: flex;
        height: 180px;
        li {
          width: 180px;
          display: flex;
          flex-direction: column;
          align-items: center;
          box-sizing: border-box;
          padding: 10px 20px 0 20px;
          margin-right: 10px;
          img {
            width: 100px;
            height: 100px;
            cursor: pointer;
          }
          p {
            width: 140px;
          }
          .tit {
            margin-top: 8px;
            height: 20px;
            font-size: 12px;
            color: rgba(96, 98, 102, 1);
            line-height: 18px;
            letter-spacing: 1px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            letter-spacing: 1px;
            cursor: pointer;
          }
          .tit:hover {
            color: rgba(223, 52, 69, 1);
          }
          .price {
            font-size: 12px;
            font-weight: 400;
            color: rgba(223, 52, 69, 1);
            line-height: 18px;
            letter-spacing: 1px;
          }
        }
      }
      .more {
        cursor: pointer;
      }
      .no-collectionList {
        width: 980px;
        height: 180px;
        text-align: center;
        line-height: 180px;
        font-size: 12px;
        color: #909399;
      }
    }
  }
  .my-recommend {
    padding: 0 20px;
    background: #fff;
    .my-recommend-main {
      height: 180px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        height: 180px;
        li {
          width: 180px;
          display: flex;
          flex-direction: column;
          align-items: center;
          box-sizing: border-box;
          padding: 10px 20px 0 20px;
          margin-right: 10px;
          img {
            width: 100px;
            height: 100px;
            cursor: pointer;
          }
          p {
            width: 140px;
          }
          .tit {
            margin-top: 8px;
            height: 20px;
            font-size: 12px;
            color: rgba(96, 98, 102, 1);
            line-height: 18px;
            letter-spacing: 1px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            letter-spacing: 1px;
            cursor: pointer;
          }
          .tit:hover {
            color: rgba(223, 52, 69, 1);
          }
          .price {
            font-size: 12px;
            font-weight: 400;
            color: rgba(223, 52, 69, 1);
            line-height: 18px;
            letter-spacing: 1px;
          }
        }
      }
      .more {
        cursor: pointer;
      }
      .no-recommendList {
        width: 980px;
        height: 180px;
        text-align: center;
        line-height: 180px;
        font-size: 12px;
        color: #909399;
      }
    }
  }
}
</style>
